import React from 'react';
import styles from './EducatorResource.module.scss';
const EducatorResource = ({ title, image, body, file }) => (
  <div className={styles.wrapper}>
    <div className={`${styles.half} `}>
      <div className={`${styles.image}`}>
        {image && <img src={image.url} alt={image.alt} />}
      </div>
    </div>
    <div className={`${styles.half} ${styles.content}`}>
      {title && <h4 className={styles.title}>{title}</h4>}
      {body && (
        <div
          className={styles.body}
          dangerouslySetInnerHTML={{ __html: body }}
        />
      )}
      {file && (
        <a className={styles.downloadLink} download href={file.url}>
          {`DOWNLOAD/${file.size}`}
        </a>
      )}
    </div>
  </div>
);

export default EducatorResource;



// WEBPACK FOOTER //
// ./src/components/basic/EducatorResource.js